<script setup lang="ts">
import MainSummary from '@desktop/views/Relation/components/RelationView/Main/MainSummary/MainSummary.vue'
import ResultWithSlider from '@desktop/views/Relation/Sports/components/RelationView/Main/Summary/ResultWithSlider.vue'

import EventClock from './EventClock/EventClock.vue'
import LineupsModal from './Lineups/LineupsModal.vue'
</script>

<template>
  <MainSummary
    :modalOptions="{
      skins: true,
      lineups: LineupsModal,
    }"
  >
    <template #bottom>
      <ResultWithSlider />
      <EventClock />
    </template>
  </MainSummary>
</template>
